module.exports = (__webpack_require__(0))(52);


//////////////////
// WEBPACK FOOTER
// delegated ./clients/web/src/views/widgets/BrowserWidget.js from dll-reference girder_lib
// module id = 45
// module chunks = 0